'use strict';
const angular = require('angular');
const {forEach} = angular;

module.exports = [
  '$provide',
  ionicDelegateDecorator];

function ionicDelegateDecorator($provide) {
  var delegates = ['$ionicSlideBoxDelegate', '$ionicScrollDelegate'];

  forEach(delegates, function decorateDelegate(delegate) {
    $provide.decorator(delegate, ['$delegate', decorateService]);

    function decorateService($delegate) {
      $delegate.$getByHandle = function $getByHandle(name) {
        var instances = this._instances;
        return instances.filter(function (element) {
          return (element['$$delegateHandle'] == name);
        })[0];
      };

      return $delegate;
    }
  })
}


// WEBPACK FOOTER //
// ./src/js/core-utilities-implementation/ionic-delegates/ionicSlideBoxDelegateDecorator.js